import http from './index'

export const getUserInfo = () => {
  return http.get({
    url: '/user/getUserInfo'
  })
}

export function getWebPage(pageName) {
  return http.post({
    url: '/bms/pcwebsite/pcWebsiteConfig/page-web',
    data: {
      page: 1,
      limit: 100,
      pageName,
      orgId: process.env.VUE_APP_ORG_ID,
    }
  })
}

// 获取官网页面配置
export const getWebDetailConfig = (data) => {
  return http.post({
    url: '/bms/pcwebsite/pcWebsiteConfig/get',
    data
  })
}
